import React, { useEffect } from "react";
import "./About.css";
import Aos from "aos";
import "aos/dist/aos.css";
import pic1 from "../../icons/aboutwork1.png";
// import bgyellow from "../../icons/bg-yellow.png";
import bgwhite from "../../icons/bg-white.png";
import witjohn from "../../icons/john.jpg";
import akshay from "../../icons/akshay.jpg";
import projectList from "../Projects/Projectlist";
import DataList from "../Home/DataList";

const About = () => {
	useEffect(() => {
		Aos.init();
	}, []);
	return (
		<>
			<div className="About">
				<p className="verticalText">MERN STACK</p>
				<div className="topBox">
					<div
						className="innerbox"
						data-aos="fade-right"
						data-aos-duration="1000"
					>
						<div className="aboutjatultext">
							<div
								className="lefttext"
								data-aos="fade-up"
								data-aos-duration="2000"
							>
								<h1>
									<span>W</span>ho is Jatul?
								</h1>
								{DataList.map((item) => {
									return (
										<>
											<p>{item.AboutTop1}</p>
											<p>{item.AboutTop2}</p>
										</>
									);
								})}
							</div>
							<div className="rightImage">
								<img class="vert-move" src={pic1} alt="img" />
							</div>
						</div>
					</div>
				</div>
				<div className="aboutjatul">
					<div className="photoSection">
						<div className="photo1">
							<div className="image">
								<img
									className="img1"
									src={bgwhite}
									alt="img"
									data-aos="fade-up"
									data-aos-duration="3000"
								/>
								<div
									className="description"
									data-aos="fade-up"
									data-aos-duration="2000"
								>
									{DataList.map((item) => {
										return (
											<>
												<p>{item.card1}</p>
											</>
										);
									})}
								</div>
							</div>
							<div className="image">
								<div
									className="description"
									data-aos="fade-left"
									data-aos-duration="2000"
								>
									{DataList.map((item) => {
										return (
											<>
												<p>{item.card2}</p>
											</>
										);
									})}
								</div>
								<img
									src={witjohn}
									alt="img"
									className="description secoundImg"
									data-aos="fade-up"
									data-aos-duration="2000"
								/>
							</div>
							<div className="image">
								<img
									className="img1"
									src={akshay}
									alt="img"
									data-aos="fade-up"
									data-aos-duration="2000"
								/>
								<div
									className="description"
									data-aos="fade-right"
									data-aos-duration="2000"
								>
									{DataList.map((item) => {
										return (
											<>
												<p>{item.card3}</p>
											</>
										);
									})}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default About;
